<template>
<div>
  <section class="content-header">
    <h1>
      语吧周内详情
      <small>学习数据</small>
    </h1>
    <ol class="breadcrumb">
      <li><a href="#/"><i class="fa fa-dashboard"></i> Home</a></li>
      <li><a href="#/learnDetails/learnDetails">学习数据</a></li>
      <li class="active">语吧周内详情</li>
    </ol>
  </section>

  <section class="content">
    <el-card class="box-card" body-style="padding-bottom:0px" v-show="!printingPDF">
      <el-form :inline="true" :model="filters">
        <el-form-item v-show="$auth.check('ROLE_QOOCO')">
          <el-select v-model="filters.orgType" filterable clearable placeholder="机构类型" @change="chOrgType">
            <el-option
              v-for="item in orgTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
				<el-form-item>
          <el-select v-model="filters.customer" filterable clearable placeholder="学校" style="width: 360px">
            <el-option
              v-for="item in modCustomers"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
        <el-form-item>
          <el-date-picker v-model="filters.dateRange" type="daterange" start-placeholder="开始日期"
            end-placeholder="结束日期" :picker-options="pickerOptions" :default-value="currentDate" value-format="yyyy-MM-dd">
          </el-date-picker>
				</el-form-item>
        <br>
				<el-form-item>
          课程类型:
          <el-select v-model="filters.featureId" filterable clearable placeholder="课程类型">
            <el-option
              v-for="item in [{id:'6',name:'大声说英语'},{id:'9',name:'萌宠'},{id:'19',name:'宝宝说英语'}]"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
        <el-form-item>
          卡密类型:
          <el-select v-model="filters.cardType" filterable placeholder="卡密类型">
            <el-option
              v-for="item in [{id:'all', name:'全部'},
                {id:'t4d365', name:'年卡'},
                {id:'d93', name:'季卡'},
                {id:'d62', name:'双月卡'},
                {id:'t3', name:'活动卡'},
                {id:'t1', name:'体验卡'},
                {id:'none', name:'无卡密'}
              ]"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="query">查询</el-button>
					<el-button type="primary" icon="el-icon-download" v-show="canPrint" @click="genPdf">生成PDF</el-button>
				</el-form-item>
			</el-form>
      <div class="duration">
        <span class="label">当前查询时间段：</span>
        <span class="value">{{dateRange[0]}} 至 {{dateRange[1]}}</span>
      </div>
    </el-card>

    <el-card class="title" v-show="printingPDF">
      <h3>{{modCustomers.find(e=>e.id===filters.customer) 
        && modCustomers.find(e=>e.id===filters.customer).name}}</h3>
      <h3>{{dateRange[0]}} ~ {{dateRange[1]}}</h3>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">线上出勤情况</span>
      </div>

      <div class="echart">
        <IEcharts :option="attendanceDistribute" :resizable="true" :loading="loading"></IEcharts>
      </div>
      <pre>
          线上出勤人数：一定周期内，学习时长非0的用户数
          总用户数：一定周期内，有过课程的用户数，包含在本周期内过期的用户
          占比 = 线上出勤人数 / 总用户数</pre>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">线上学习时长分布情况</span>
      </div>

      <div class="echart">
        <IEcharts :option="learnDurationDistribute" :resizable="true" :loading="loading"></IEcharts>
      </div>
      <pre>
          线上学习时长：一定周期内，同一用户学习时长的平均值
          总用户数：一定周期内，有过课程的用户数，包含在本周期内过期的用户
          占比 = 线上学习时长平均值到达某学习时长区间的人数 / 总用户数</pre>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">星星获得情况</span>
      </div>

      <div class="echart">
        <IEcharts :option="starDistribute" :resizable="true" :loading="loading"></IEcharts>
      </div>
      <pre>
          星星数量：一定周期内，同一用户学习所获得的星星数量
          总用户数：一定周期内，有过课程的用户数，包含在本周期内过期的用户
          占比 = 星星数量到达某星星数量区间内的人数 / 总用户数</pre>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">巧口秀使用情况</span>
      </div>

      <div class="echart">
        <IEcharts :option="qoocoShowDistribute" :resizable="true" :loading="loading"></IEcharts>
      </div>
      <pre>
          巧口秀视频数量：一定周期内，同一用户上传巧口秀视频的数量
          总用户数：一定周期内，有过课程的用户数，包含在本周期内过期的用户
          占比 = 上传巧口秀数量在某区间的人数 / 总用户数</pre>
    </el-card>

  </section>
</div>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full'
import {mapGetters} from 'vuex'
import {loadQoocobarStatistics} from 'api/learn-details'
import {getLastWeek, parseTwoArray} from 'common/js/app-utils'
import html2pdf from 'html2pdf.js'
import moment from 'moment'
// import {Loading} from 'element-ui'

var _ = require('lodash') // 深拷贝
var colors = ['rgb(91,155,213)', '#ef3e42']

export default {
  computed: {
    ...mapGetters([
      'orgTypes',
      'customers',
      'pickerOptions'
    ])
  },
  data () {
    return {
      modCustomers: [],
      canPrint: false,
      printingPDF: false,
      dateRange: [],
      currentDate: new Date(),
      filters: {
        customer: [],
        dateRange: [],
        orgType: '',
        featureId: '6',
        cardType: 'all'
      },

      loading: true,

      attendanceDistribute: {},
      learnDurationDistribute: {},
      starDistribute: {},
      qoocoShowDistribute: {}
    }
  },
  components: {
    IEcharts
  },
  created () {
    [{k: 'attendance', v: '线上出勤（天）', type: 'bar'},
    {k: 'learnDuration', v: '线上平均学习时长(分钟)', type: 'bar'},
    {k: 'star', v: '星星数量（颗）', type: 'bar'},
    {k: 'qoocoShow', v: '巧口秀视频数量（个）', type: 'bar'}
    ].forEach(obj => {
      // 创建柱形图------------------------------------------
      this[obj.k + 'Distribute'] = {
        title: {
          text: `${obj.v}分布`,
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          confine: true,
          formatter: param => {
            let o = param[0]
            let t = param[1]
            return `${o.axisValue}<br/>${o.marker + o.seriesName}: ${o.data}<br/>
            ${t.marker + t.seriesName}: ${Number(t.data * 100).toFixed(0)}%`
          },
          axisPointer: {
            type: 'cross'
          }
        },
        grid: {x: '15%', y: '14%', width: '70%', height: '70%'},
        legend: {
          data: [`人数`, `占比`],
          bottom: 5
        },
        xAxis: {
          data: []
        },
        yAxis: [
          {
            type: 'value',
            name: `人数`,
            min: 0,
            position: 'left',
            axisLine: {
              lineStyle: {
                color: colors[0]
              }
            },
            axisLabel: {
              formatter: '{value} 人'
            }
          },
          {
            type: 'value',
            name: `占比`,
            min: 0,
            max: 1,
            position: 'right',
            axisLine: {
              lineStyle: {
                color: colors[1]
              }
            },
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: `人数`,
            type: 'bar',
            data: []
          },
          {
            name: `占比`,
            type: 'line',
            showAllSymbol: true,
            yAxisIndex: 1,
            data: [],
            label: {
              normal: {
                show: true,
                position: 'top',
                color: 'black',
                formatter: (params) => {
                  return `${Number(params.value * 100).toFixed(0)}%`
                }
              }
            }
          }
        ],
        color: colors
      }
    })
  },
  mounted () {
    this.chOrgType()
    this.query()
  },
  methods: {
    query () {
      this._showDateRange(this._loadQoocobarStatistics)
    },
    _showDateRange (callback) {
      let t = _.cloneDeep(this.filters.dateRange)
      console.log(t)
      if (t && t.length === 2) {
        this.dateRange = t
        callback()
      } else {
        this.dateRange = getLastWeek()
        callback()
      }
    },
    _loadQoocobarStatistics () {
      this.canPrint = false
      this.loading = true
      let dateRange = this.dateRange
      console.log(dateRange)
      let m0 = moment(dateRange[0], 'YYYY-MM-DD')
      let m1 = moment(dateRange[1], 'YYYY-MM-DD')
      let mMax = moment(m0).add(7, 'days')
      let isIn7day = m1.format('YYYYMMDD') < mMax.format('YYYYMMDD')
      if (isIn7day) { // 一周以内的时间段
        loadQoocobarStatistics(this.filters)
        .then(res => {
          this.canPrint = true
          this.loading = false
          let maxNumFeatured = res.maxNum
          let maxNumAll = res.maxNum2;
          ['attendance', 'learnDuration', 'star', 'qoocoShow'].forEach(item => {
            let maxNum = item === 'qoocoShow' ? maxNumAll : maxNumFeatured
            // 填充柱状图（比例）
            let distributionKV = parseTwoArray(res[item], this._getDistributeMap(item))
            this[`${item}Distribute`].yAxis[0].max = maxNum // 总用户数
            this[`${item}Distribute`].xAxis.data = distributionKV.keys
            this[`${item}Distribute`].series[0].data = distributionKV.values
            // 占比
            let rates = []
            distributionKV.values.forEach(t => rates.push(t / maxNum))
            this[`${item}Distribute`].series[1].data = rates
          })
        }, msg => {
          this.canPrint = false
          this.loading = false
          this._resetData()
          this.$message.error(msg)
        })
      } else {
        this.canPrint = false
        this.loading = false
        this._resetData()
        this.$message.error(`请选择一周以内的时间段！`)
      }
    },
    _getDistributeMap (item) {
      let map = new Map()
      switch (item) {
        case 'attendance':
          map.set('day0', '0')
          map.set('day1', '1')
          map.set('day2', '2')
          map.set('day3', '3')
          map.set('day4', '4')
          map.set('day5', '5')
          map.set('day6', '6')
          map.set('day7', '7        天')
          break
        case 'learnDuration':
          map.set('min_10', '<10')
          map.set('min10_15', '10~15')
          map.set('min16_20', '15~20')
          map.set('min21_30', '20~30')
          map.set('min31_50', '30~50')
          map.set('min51_70', '50~75')
          map.set('min71_', '≥75        分钟')
          break
        case 'star':
          map.set('star_15', '0-15')
          map.set('star16_30', '16~30')
          map.set('star31_45', '31~45')
          map.set('star46_60', '46~60')
          map.set('star61_75', '61~75')
          map.set('star_others', '其他        颗')
          break
        case 'qoocoShow':
          map.set('show0', '0')
          map.set('show1', '1')
          map.set('show2', '2')
          map.set('show_others', '其他        个')
          break
      }
      return map
    },
    chOrgType () {
      if (this.filters.orgType === '' || this.filters.orgType === 'all') {
        this.modCustomers = this.customers
      } else {
        this.filters.customer = []
        this.modCustomers = this.customers.filter(t => t.type === this.filters.orgType)
      }
    },
    _resetData () {
      ['attendance', 'learnDuration', 'star', 'qoocoShow'].forEach(item => {
        // 清空柱状图（比例）
        this[`${item}Distribute`].xAxis.data = []
        this[`${item}Distribute`].series[0].data = []
        this[`${item}Distribute`].series[1].data = []
      })
    },
    genPdf () {
      let _this = this
      let customer = _this.customers.filter(t => t.id === _this.filters.customer)[0]
      let filename = `${customer.name}(${this.dateRange[0]}~${this.dateRange[1]}).pdf`
      let dom2Print = document.querySelector('.content')
      let originWidth = dom2Print.style.width
      dom2Print.style.width = '800px'
      this.printingPDF = true
      setTimeout(() => {
        html2pdf().from(dom2Print).save(filename).then(() => {
          dom2Print.style.width = originWidth
          _this.printingPDF = false
        })
      }, 1000)
    }
  }
}
</script>


<style lang="stylus" scoped>
  @import '~common/stylus/base'
  .echart
    margin 30px 0
  .title
    text-align: center
</style>



// WEBPACK FOOTER //
// src/components/learn-details/learn-details-qoocobar.vue